<template>
    <div>
        <button
            type="button"
            @click="open = !open"
            class="border mt-1 block pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md mt-1 w-full"
        >
            {{ selectedOption ? selectedOption.text : $t('messages.select') }}
        </button>
        <SlideOver :show="open" @close="open = false">
            <div class="flex justify-end">
                <AppButton element="button" type="button" class="" @click="select(null)">
                    {{ $t('messages.remove') }}
                </AppButton>
            </div>

            <FormInput v-model.trim="search" ref="text" :placeholder="$t('messages.search')" class="w-full mt-5" />

            <div class="">
                {{ $t('messages.select') }}
            </div>
            <div class="space-y-4" v-if="optgroups">
                <transition-group
                    class=""
                    enter-active-class="transition-opacity ease-linear duration-300"
                    enter-from-class="opacity-0"
                    enter-to-class="opacity-100"
                    leave-active-class="transition-opacity ease-linear duration-300"
                    leave-from-class="opacity-100"
                    leave-to-class="opacity-0"
                    tag="span"
                >
                    <!--
                      Checked: "border-transparent", Not Checked: "border-gray-300"
                      Active: "ring-2 ring-indigo-500"
                    -->
                    <template v-for="optgroup in filteredOptions" :key="optgroup.label">
                        <div class="font-semibold pt-2 pb-1">
                            {{ optgroup.label }}
                        </div>
                        <ul>
                            <li
                                v-for="option in optgroup.options"
                                @click="select(option.value)"
                                :key="option.value"
                                class="hover:bg-indigo-200 px-1 py-1 rounded"
                            >
                                <button type="button" class="w-full text-left inline-block">
                                    {{ option.text }}
                                </button>
                            </li>
                        </ul>
                    </template>
                </transition-group>
            </div>
        </SlideOver>
    </div>
</template>

<script>
import SlideOver from '@/components/SlideOver.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import deburr from 'lodash/deburr.js';
import AppButton from '@/components/AppButton.vue';

export default {
    name: 'FormSelectFilterablePanel',
    components: {
        SlideOver,
        FormInput,
        AppButton,
    },
    props: {
        modelValue: {
            required: true,
        },
        options: {
            required: false,
            type: Array,
            default: () => [],
        },
        optgroups: {
            required: false,
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            open: false,
            search: '',
            selected: this.modelValue,
        };
    },
    watch: {
        selected(newVal) {
            this.$emit('update:modelValue', newVal);
        },
        open(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    this.focusInput();
                });
            }
        },
    },
    computed: {
        filteredOptions: function () {
            if (this.search.trim() === '') {
                return this.options;
            }
            const searchString = deburr(this.search.trim().toUpperCase());

            return this.options
                .map((optgroup) => {
                    return {
                        label: optgroup.label,
                        options: optgroup.options.filter((option) => {
                            return deburr(option.text.toUpperCase()).includes(searchString);
                        }),
                    };
                })
                .filter((optgroup) => optgroup.options.length);
        },
        selectedOption() {
            if (!this.selected) {
                return null;
            }

            return this.options.flatMap((o) => o.options).find((o) => o.value === this.selected);
        },
    },
    methods: {
        select(id) {
            this.selected = id;
            this.open = false;
        },
        focusInput() {
            this.$nextTick(function () {
                this.$refs.text.focusInput();
            });
        },
    },
};
</script>
